import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { TicketService } from '../../services/ticket-service';
import { Ticket } from '../../models/entities/ticket';
import { TicketCategory } from '../../models/entities/ticket-category-entity';
import { TicketType } from '../../models/entities/ticket-type-entity';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetLovComponent } from '../asset-lov/asset-lov.component';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { TicketTypeLovComponent } from '../ticket-type-lov/ticket-type-lov.component';
import { marker } from 'src/app/tools/models/entities/marker';
import { TicketBatch } from '../../models/entities/ticket-batch';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { TicketBatchTicket } from '../../models/entities/ticket-batch-ticket';
import { Field } from 'src/app/tools/models/dtos/field';
import { TicketPipe } from '../../pipes/ticket-pipe';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { AssetProductCategoryLovComponent } from '../asset-product-category-lov/asset-product-category-lov.component';
import { ItineraryLovComponent } from 'src/app/assabil-admin/components/master-data/partner/itinerary-lov/itinerary-lov.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'ticket-list',
    templateUrl: './ticket-list.component.html',
    styleUrls: ['./ticket-list.component.scss']
})


export class TicketListComponent extends BasePage2<Ticket> {

    
  @Input() ticketBatch : TicketBatch;

    // Filter fields
    // ---------------------------------------------------
    id                      : number;
    ticketCategory          : TicketCategory;
    ticketType              : TicketType;

    branch                  : Branch;
    partner                 : Partner;
    itinerary               : Itinerary;

    assetBarCode            : string;
    assetProductCategory    : AssetProductCategory;

    priority                : number

    newlyCreated_PL 		    :  boolean = true;
    toBeQualified_PL        :  boolean = true;
    qualified_PL            :  boolean = true;
    scheduled_PL            :  boolean = true;
    processed_PL            :  boolean = true;
    closed_PL               :  boolean = false;



  ticketCategoryLovComponent       = TicketTypeLovComponent;   
  ticketTypeLovComponent           = TicketTypeLovComponent;   
  branchLovComponent               = BranchLovComponent;
  partnerLovComponent              = PartnerLovComponent;
  itineraryLovComponent            = ItineraryLovComponent;
  assetProductCategoryLovComponent = AssetProductCategoryLovComponent

    priorityLov = [
      {name : 'Faible', priority : 1},
      {name : 'Normal', priority : 2},
      {name : 'Haute',  priority : 3}
    ];

    // ---------------------------------------------------


    tickets: Ticket[] = [];
    selectedColumn  = { prop: 'selected',     name: 'S', type : 'boolean' } 


    constructor(
        protected toastr        : ToastrService,
        protected ticketService : TicketService,
        protected router        : Router,
        protected baseService   : BaseService,
        protected userService   : UserService,
        protected leanUtilsService  : LeanUtilsService, 
        protected dialog        : MatDialog,
        protected location      : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'ticket';
    }

    //----------------------------------------------------------------------
    ngAfterViewInit(): void {
        super.ngAfterViewInit();
        this.setChildFields();
        this.buildPoints();
    }
  //----------------------------------------------------------------------


    //----------------------------------------------------------------------
    getRows(): Ticket[] {
        return this.tickets;
    }
    //----------------------------------------------------------------------
    

    //------------------------------------------------------------------------------------------------------
    newTicket(){
    let ticket : Ticket = new Ticket();
    ticket.progressLevel = 0;
    ticket.inserted     = true;
    ticket.edit         = true;

    let dialogRef = this.dialog.open(AssetLovComponent, {autoFocus : false, hasBackdrop : false});
    dialogRef.afterClosed().subscribe(asset => {
      if(asset){
        ticket.asset    = asset;
        ticket.branch   = ticket.asset.branch;
        ticket.partner  = ticket.asset.partner;
        this.newTicket2(ticket);
      }
    });
        
  }


    newTicket2(ticket : Ticket ){    
      let dialogRef = this.dialog.open(TicketTypeLovComponent, {autoFocus : false, hasBackdrop : false});
      dialogRef.afterClosed().subscribe(ticketType => {
        if(ticketType){
          ticket.ticketType = ticketType;
          this.selectedRow  = ticket;
        }
      });
    }
    //------------------------------------------------------------------------------------------------------



    //----------------------------------------------------------------------
    loadData() {
      let ticketCategoryId        : number; //if (this.ticketCategory) ticketCategoryCode = this.ticketCategory.ticketCategoryCode;
      let ticketTypeId            : number; if (this.ticketType)     ticketTypeId         = this.ticketType.id;
  
      let branchCode              : string; if (this.branch)        branchCode             = this.branch.branchCode;
      let partnerCode             : string; if (this.partner)       partnerCode            = this.partner.partnerCode;
      let itineraryCode           : string; if (this.itinerary)     itineraryCode          = this.itinerary.itineraryCode;
      let ticketBatchId           : number; if (this.ticketBatch)   ticketBatchId          = this.ticketBatch.id;

  
      let assetProductCategoryCode: string;
      if (this.assetProductCategory) assetProductCategoryCode = this.assetProductCategory.assetProductCategoryCode;
  
      this.ticketService.ticketsGet(        
                        this.id               ,
                        ticketCategoryId      ,
                        ticketTypeId            ,
                    
                        branchCode              ,
                        partnerCode             ,
                        itineraryCode           ,
                    
                        this.assetBarCode       ,
                        assetProductCategoryCode,
                    
                        this.priority           ,
                    
                        this.newlyCreated_PL 	  ,
                        this.toBeQualified_PL,
                        this.qualified_PL       ,
                        this.scheduled_PL       ,
                        this.processed_PL       ,
                        this.closed_PL,
                        ticketBatchId          ).then(tickets => {
              this.tickets = tickets;
              if (this.ticketBatch) this.buildPoints();
            });     
    }
       //----------------------------------------------------------------------


    //----------------------------------------------------------------------
   closeWidget(ticket: Ticket) {
          if (ticket != null) {
              this.tickets[this.tickets.indexOf(<Ticket>this.selectedRow)] = ticket;
          }
          this.selectedRow = null;
      }
   //----------------------------------------------------------------------

        
      
    //----------------------------------------------------------------------
    setChildFields(){
        this.baseService.fieldsGet('formField').then(result => {
            this.childFields = result.listFields;
            this.readOnly    = result.readOnly;

            this.childFields.forEach(field => {
                if (field.prop == 'term.termCode') {
                  //  field.modal = TermLovComponent;
                }
            })

        }) 
    }
    //--------------------------------------------------------------------------------------------------------


  //--------------------------------------------------------------------------------------------------------
  points               : marker[] = [];
  ticketsPartners      : Partner[] = [];
  ticketBatchsPartners : Partner[] = [];
  allMapPartners       : Partner[] = [];
  buildPoints(){
    this.points = [];

    // Populate ticketBatchsPartners
    //----------------------------------------------------------------------------------------------
    if (this.ticketBatch) {
      this.ticketBatch.ticketBatchTickets.forEach(ticketBatchTicket => {
        let found : boolean = false;
        this.ticketBatchsPartners.forEach(partner => {
          if(partner.partnerCode == ticketBatchTicket.ticket.partner.partnerCode) found = true;
        });
        if (! found) this.ticketBatchsPartners.push(ticketBatchTicket.ticket.partner);
      });
    }
    //----------------------------------------------------------------------------------------------
  
    // Populate ticketsPartners
    //----------------------------------------------------------------------------------------------
    this.tickets.forEach(ticket => {
        if (ticket.partner){
            let found : boolean = false;

            // check in ticketBatchsPartners
            this.ticketBatchsPartners.forEach(partner => {
              if(partner.partnerCode == ticket.partner.partnerCode) found = true;
            });
    
            if (! found) {
              // check in ticketsPartners
              this.ticketsPartners.forEach(partner => {
                if(partner.partnerCode == ticket.partner.partnerCode) found = true;
              });
            }
    
            if (! found) this.ticketsPartners.push(ticket.partner);
        }
      });
    //----------------------------------------------------------------------------------------------
    

    // Populate points
    //----------------------------------------------------------------------------------------------
    this.ticketBatchsPartners.forEach(partner => {
      if ((partner.latitude) && (partner.longitude)) {
        let point : marker = {     
          lat       : partner.latitude,
          lng       : partner.longitude,
          label     : partner.name,
          draggable : false,
          iconUrl   : 'http://maps.google.com/mapfiles/ms/icons/blue.png'
        };
        this.points.push(point);
        partner.point = point;
        this.allMapPartners.push(partner);
      }
    });

    this.ticketsPartners.forEach(partner => {
      if ((partner.latitude) && (partner.longitude)) {
        let point : marker = {     
          lat       : partner.latitude,
          lng       : partner.longitude,
          label     : partner.name,
          draggable : false,
          iconUrl   : 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
        };
        this.points.push(point);
        partner.point = point;
        this.allMapPartners.push(partner);
      }
    });
  
  }

  onSelectPoint(index : number) {
    
    if (index < this.ticketBatchsPartners.length) {
      // It's releated to partner in ticketBatchsPartners
      return;
    } else {
      // It's releated to partner in ticketsPartners
      
      // Toggle selected value for partner
      //let selectedPartner : Partner = this.ticketsPartners[index - this.ticketBatchsPartners.length];
      let selectedPartner = this.allMapPartners[index];
      selectedPartner.selected = !selectedPartner.selected 

      // Set selected value for all partner tickets
      this.tickets.forEach(ticket => {
          if ((ticket.partner) && (ticket.partner.partnerCode == selectedPartner.partnerCode)){
            ticket.selected = selectedPartner.selected;
          }
      });

      // Set the right icon
      if (selectedPartner.selected) {
        selectedPartner.point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green.png';
      }else {
        selectedPartner.point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow.png';
      }
    }
  }

  
    //--------------------------------------------------------------------------------------------------------
    selectRow(ticket : Ticket){
      
      if ( ! this.ticketBatch) {
        this.ticketService.ticketGet(ticket.id).then(ticket => {
            this.selectedRow = ticket;
        }); 
        return;
      }


      // Toggle selected value if the ticket
      //----------------------------------------------------------------
      ticket.selected = ! ticket.selected;
      //----------------------------------------------------------------

      let partnerSelected : boolean = ticket.selected;
      if (! ticket.selected){
        // Find if any other ticket of the same partner is currently selected
        for (let tk of this.tickets){
          if ( (tk.partner) && (tk.partner.partnerCode == ticket.partner.partnerCode) && (tk.selected) ) {
            partnerSelected = true;
            break;
          }
        }
      }

     // Retrieve ticket partner in ticketsPartners list
      //----------------------------------------------------------------
      let partner : Partner;
      for (let p of this.ticketsPartners){
        if (p.partnerCode == ticket.partner.partnerCode) {
          partner = p;
          break;
        }
      }   
      partner.selected = partnerSelected;
      //----------------------------------------------------------------

      //----------------------------------------------------------------
      if (partner.selected) {
        partner.point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green.png';
      } else {
        partner.point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/yellow.png';
      }
      //----------------------------------------------------------------

    }
    //--------------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------
  processFields(){
    super.processFields();
    if (this.ticketBatch) this.listFields.unshift(this.selectedColumn);
  }
  //----------------------------------------------------------------------


  ticketPipe : TicketPipe = new TicketPipe();
  //----------------------------------------------------------------------
  enrichField(field : Field){
    if ( (field.prop == 'progressLevel') || (field.prop == 'priority')) {
        field.pipe = this.ticketPipe;
    }

  }
  //---------------------------------------------------------------------------------------


  addSelectedTickets(){
    if (! this.ticketBatch) return;

    if (! this.ticketBatch.ticketBatchTickets) this.ticketBatch.ticketBatchTickets = [];
    this.tickets.forEach(ticket => {
      if (ticket.selected){
        let alreadyThere : boolean = false;
        this.ticketBatch.ticketBatchTickets.forEach( tbt =>{
            if (tbt.ticket.id == ticket.id) {
              alreadyThere = true;
            }
        });
        if (! alreadyThere) {
          let ticketBatchTicket : TicketBatchTicket = new TicketBatchTicket();
          ticketBatchTicket.ticket = ticket;
          ticketBatchTicket.rank = 0;
          this.ticketBatch.ticketBatchTickets.push(ticketBatchTicket);
        }
      }
    });
    this.ticketBatch.ticketBatchTickets = [...this.ticketBatch.ticketBatchTickets];
    this.ticketBatch.edit = true;
    this.ticketBatch.updated = true;
  }
}



